export default __webpack_public_path__ + "static/media/set_remote_off_icon.75121bd5.svg";